import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AUTH0_RETURN_TO_KEY } from '../helpers/auth0Config';
import { useAuth0 } from '../__mocks__/@auth0/auth0-react';

// Runs inside the Router. After a login round trip lands on the fixed
// redirect_uri (/dashboard), navigates to the deep link the user originally
// requested, stashed in sessionStorage by onRedirectCallback.
const AuthRedirectHandler = () => {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    const returnTo = window.sessionStorage.getItem(AUTH0_RETURN_TO_KEY);
    if (returnTo) {
      window.sessionStorage.removeItem(AUTH0_RETURN_TO_KEY);
      navigate(returnTo, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return null;
};

export default AuthRedirectHandler;
